import { UntypedFormBuilder } from "@angular/forms";
import { Entity } from "../../entity/model/Entity";

export interface EmployeeCompany  {

    id: number;
    entityId: number;
    createdBy?: string;
    timestamp?: string;
    entity?: Entity;

}


export class EmployeeCompanyFormBuilder {

    static getForm(fb: UntypedFormBuilder, EmployeeCompany: EmployeeCompany) {

        return fb.group(
            {
                id: [EmployeeCompany.id],
                entityId: [EmployeeCompany.entityId],
            }
        );
    }

    static initEmployeeCompany(): EmployeeCompany {

        return {
            id: 0,
            entityId: 0,
        };
    }
}